import React from "react";

function BasicToggleButton({ className, children, onClick, checked }) {
  const toggledClassName = checked
    ? "text-white bg-blue-400"
    : "text-blue-400 bg-gray-200";
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${toggledClassName} ${className} p-2 ml-1 mr-1 border-2 text-sm uppercase text-center font-bold rounded-md border-blue-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`}
    >
      {children}
    </button>
  );
}

export default BasicToggleButton;
